<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add New Project</p>
        <button class="delete"  @click="$emit('closeModal')"></button>
      </header>
      <section class="modal-card-body">
        <ProjectForm
          :project.sync="project"
          :newProject="true"
        />
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="createProject">Create Project</button>
        <button class="button" @click="$emit('closeModal')">Cancel</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProjectForm from '@/components/ProjectForm.vue';

export default {
  name: 'new-project-modal',
  components: {
    ProjectForm,
  },
  data() {
    return {
      project: {},
    };
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
      jwt: state => state.profile.jwt,
    }),
    API() {
      return this.$API;
    },
  },
  methods: {
    createProject() {
      const method = 'POST';
      const url = `${this.$API}/projects/`;
      this.axios({
        method,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        data: this.project,
        url,
      })
        .then((response) => {
          if (response.status === 200) {
            this.$emit('closeModal');
          }
        })
        .catch(err => console.log(err));
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
